import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    body: 'When you make a bank transfer or a card payment, the transaction is often processed **the next business day**.\n\nYou will be able to close your account once all pending transactions have been validated.',
    title: 'Transactions are still in progress on your account',
  },
  fr: {
    body: 'Lorsque vous effectuez un virement ou un paiement par carte, l’opération est souvent traitée **le jour ouvré suivant**.\n\nVous pourrez procéder à la clôture de votre compte une fois que toutes les transactions en attente auront été validées.',
    title: 'Des opérations sont encore en cours sur votre compte',
  },
});

export default locales;
